module.exports = __webpack_public_path__ + "e1ca526af1db425339eaaa972ec5e9dd.svg";